module.exports = __webpack_public_path__ + "img/5.9a93be00.png";